var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.98296 0.239108C5.614 -0.0800146 5.38234 -0.0786233 5.0091 0.244674L0.302776 4.31628C0.252367 4.35988 0.200883 4.40301 0.154228 4.4494C-0.0479465 4.65024 -0.0506297 4.8984 0.145646 5.06306C0.341921 5.22773 0.628291 5.22541 0.857279 5.05007C0.899644 5.01714 0.938257 4.9805 0.979014 4.94571C2.24604 3.85135 3.5129 2.75684 4.77957 1.66218C4.83749 1.61208 4.89916 1.56523 4.99944 1.48452V10.9835C5.18463 10.9953 5.37126 11.0012 5.55931 11.0012C5.70839 11.0012 5.8564 10.997 6.00334 10.99C6.00334 7.91105 6.00334 4.83222 6.00334 1.75355V1.48128C6.10255 1.56245 6.15886 1.60651 6.21249 1.6529C7.47451 2.74354 8.73618 3.83419 9.99749 4.92484C10.0709 4.99235 10.1507 5.05442 10.2361 5.11037C10.3327 5.17016 10.4517 5.19642 10.5696 5.18397C10.6874 5.17151 10.7956 5.12125 10.8727 5.04311C11.07 4.85062 11.0373 4.61221 10.7804 4.39003L5.98296 0.239108Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrowUp.37fa87e4fb7fa22caf77713dbcfc575f.svg";
export { ForwardRef as ReactComponent };